import { useEffect } from 'react'
import { Platform, View, Modal } from 'react-native'
import { JoinFlowLoadingScreen } from '../src/join/components/JoinFlowLoadingScreen'
import {
  oauthCallbackStyles,
  WEB_OAUTH_CSS,
  OAUTH_CALLBACK_STYLE_ID,
} from '../appStyles/_oauth-native-callback.styles'
import { useOAuthCallbackRedirect } from '../src/signIn/hooks/useOAuthCallbackRedirect'
import { authLiveDebug } from '../src/signIn/helpers/authLiveDebug.helper'

export default function OAuthNativeCallbackScreen() {
  const { isProcessing, loadingMessage, isLoaded } = useOAuthCallbackRedirect()

  useEffect(() => {
    authLiveDebug('OAuthNativeCallbackScreen render', { isProcessing, isLoaded })
  }, [isProcessing, isLoaded])

  useEffect(() => {
    if (Platform.OS === 'web') {
      const style = document.createElement('style')
      style.id = OAUTH_CALLBACK_STYLE_ID
      style.textContent = WEB_OAUTH_CSS
      document.head.appendChild(style)
    }
    return () => {
      if (Platform.OS === 'web') {
        document.getElementById(OAUTH_CALLBACK_STYLE_ID)?.remove()
      }
    }
  }, [])

  return (
    <Modal
      visible={isProcessing || !isLoaded}
      transparent={false}
      animationType="fade"
      statusBarTranslucent
      onRequestClose={() => undefined}
    >
      <View style={oauthCallbackStyles.fullScreenContainer}>
        <JoinFlowLoadingScreen message={loadingMessage} />
      </View>
    </Modal>
  )
}
